module.exports = {
  weTransferKey: 'a6GcEkikYp3XBq8NOm3dC4EOUNoHmi2r9TmXpIoH',
};
